export default __webpack_public_path__ + "static/media/wick.82ee7de1.png";